import React from 'react';
import './App.css';
import Contact from './components/contact/Contact';
import HeroSection from './components/herosection/HeroSection';
import NavBar from './components/navbar/NavBar';
import Portfolio from './components/portfolio/Portfolio';
import Services from './components/services/Services';
import Blog from './components/blog/Blog'; // 1. Added Import

function App() {

  return (
    <div className="App">
      <NavBar />

      <section id="home">
        <HeroSection />
      </section>

      <section id="services">
        <Services />
      </section>

      <section id="portfolio">
        <Portfolio />
      </section>

      {/* 2. Added Blog Section */}
      <section id="blog">
        <Blog />
      </section>

      {/* Contact Section */}
      <Contact />

      {/* Footer */}
      <footer style={{ 
          background: '#111', 
          color: '#fff', 
          padding: '40px 20px', 
          textAlign: 'center', 
          borderTop: '1px solid #222' 
      }}>
        <div style={{ marginBottom: '10px', fontSize: '14px', letterSpacing: '1px' }}>
          &copy; 2025 Sry Interiors. All rights reserved.
        </div>

        <div style={{ fontSize: '12px', color: '#666' }}>
          Designed & Developed by{' '}
          <span style={{ color: '#d4af37', fontWeight: '600', cursor: 'pointer' }}>
              Chaithanya
          </span>
        </div>
      </footer>
    </div>
  );
}

export default App;